import _classCallCheck from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
/**
 * 初始化和加载baidu地图
 */

import React from 'react';
import { requireScript } from '@uiw/react-baidu-map-utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function delay(time) {
  return new Promise(function (resolve, reject) {
    window && window.setTimeout(resolve, time);
  });
}
var DEFAULT_RETRY_TIME = 3;
/**
 * APILoader 用于加载百度地图依赖
 */

var APILoader = /*#__PURE__*/function (_React$Component) {
  _inherits(APILoader, _React$Component);

  var _super = _createSuper(APILoader);

  function APILoader(props) {
    var _this2;

    _classCallCheck(this, APILoader);

    _this2 = _super.call(this, props);
    _this2.isMountedOk = false;

    _this2.handleError = function (error) {
      if (_this2.isMountedOk) {
        _this2.setState({
          error: error
        });
      }
    };

    _this2.finish = function () {
      if (window && _this2.props.type === 'webgl') {
        window.BMap = window.BMapGL;
      }

      if (_this2.isMountedOk) {
        _this2.setState({
          loaded: true
        });
      }
    };

    _this2.state = {
      loaded: props.type === 'webgl' ? window && !!window.BMapGL && !!window.BMapGL.Map : window && !!window.BMap && !!window.BMap.Map
    };

    if (_this2.props.akay == null) {
      throw new TypeError('BaiDuMap: akay is required');
    }

    return _this2;
  }

  _createClass(APILoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMountedOk = true;
      var callbackName = this.props.callbackName;

      if (!window || !callbackName) {
        return;
      }

      if (this.props.type === 'webgl' && window && window.BMapGL && !window.BMapGL.Map || this.props.type === 'webgl' && window && !window.BMapGL || window && window.BMap && !window.BMap.Map || window && !window.BMap) {
        if (window && window[callbackName]) {
          APILoader.waitQueue.push([this.finish, this.handleError]);
          return;
        }

        this.loadMap();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isMountedOk = false;
    }
  }, {
    key: "render",
    value: function render() {
      if (window && window.BMapGL && this.props.type === 'webgl') {
        window.BMap = window.BMapGL;
      }

      return this.state.loaded ? this.props.children : this.props.fallback ? this.props.fallback(this.state.error) : this.state.error ? /*#__PURE__*/_jsx("div", {
        style: {
          color: 'red'
        },
        children: this.state.error.message
      }) : null;
    }
  }, {
    key: "getScriptSrc",
    value: function getScriptSrc() {
      var cfg = this.props;
      var protocol = cfg.protocol || window.location.protocol;

      if (protocol.indexOf(':') === -1) {
        protocol += ':';
      }

      var args = ["v=" + cfg.version, "ak=" + cfg.akay, "callback=" + cfg.callbackName];

      if (cfg.type) {
        args.push("type=" + cfg.type);
      }

      return protocol + "//" + cfg.hostAndPath + "?" + args.join('&');
    }
    /**
     * load BaiduMap in script tag
     */

  }, {
    key: "loadMap",
    value: function loadMap() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var callbackName, src, i, _ret;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callbackName = _this.props.callbackName;

                if (!(!window || !callbackName)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                src = _this.getScriptSrc();

                window[callbackName] = function () {
                  // flush queue
                  var queue = APILoader.waitQueue;
                  APILoader.waitQueue = [];
                  queue.forEach(function (task) {
                    return task[0]();
                  });

                  _this.finish();
                };

                i = 0;

              case 6:
                if (!(i < DEFAULT_RETRY_TIME)) {
                  _context.next = 24;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return requireScript(src);

              case 10:
                return _context.abrupt("break", 24);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](7);

                if (!(i === DEFAULT_RETRY_TIME - 1)) {
                  _context.next = 19;
                  break;
                }

                _ret = function () {
                  var err = new Error("Failed to load Baidu Map: " + _context.t0.message); // flush queue

                  var queue = APILoader.waitQueue;
                  APILoader.waitQueue = [];
                  queue.forEach(function (task) {
                    return task[1](err);
                  });

                  _this.handleError(err);

                  return {
                    v: void 0
                  };
                }();

                if (!(typeof _ret === "object")) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", _ret.v);

              case 19:
                _context.next = 21;
                return delay(i * 1000);

              case 21:
                i++;
                _context.next = 6;
                break;

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 13]]);
      }))();
    }
  }], [{
    key: "ready",
    value:
    /**
     * 全局可能存在多个Loader同时渲染, 但是只能由一个负责加载
     */

    /**
     * 等待BMap就绪
     */
    function ready() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(window && window.BMap.Map)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!(window && window.BMapGL.Map)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                return _context2.abrupt("return", new Promise(function (res, rej) {
                  APILoader.waitQueue.push([res, rej]);
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }]);

  return APILoader;
}(React.Component);

export { APILoader as default };
APILoader.defaultProps = {
  akay: '',
  hostAndPath: 'api.map.baidu.com/api',
  version: '2.0',
  callbackName: 'load_bmap_sdk',
  type: ''
};
APILoader.waitQueue = [];